// Application version configuration
export const APP_VERSION = 'v2.1.0';
export const BUILD_DATE = new Date().toISOString().split('T')[0];
export const ENVIRONMENT = process.env.NODE_ENV || 'development'; 